import { apiAnalytics } from "@/api/analytics/analytics.api.ts";
import {
  ApiAnalyticsTimeOffBalanceFilter,
  ApiAnalyticsTimeOffBalanceSummaryFilter,
  ApiAnalyticsTimeOffLeavePolicyFilter,
  ApiAnalyticsTimeOffLeaveUsedFilter,
} from "@/types/analytics/analytics.time-off.types.ts";
import { ApiErrorException } from "@/types/api.types.ts";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQuery } from "@tanstack/react-query";

export const timeOffAnalyticsKeys = createQueryKeys("analytics.time-off", {
  balancesSummary: (filter: ApiAnalyticsTimeOffBalanceSummaryFilter) => ({
    queryKey: [filter],
    queryFn: async ({ signal }) => {
      const result = await apiAnalytics.timeOff.balancesSummary(filter, signal);
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
  }),
  balancesByCategoryReport: (filter: ApiAnalyticsTimeOffBalanceFilter) => ({
    queryKey: [filter],
    queryFn: async ({ signal }) => {
      const result = await apiAnalytics.timeOff.balancesReport(filter, signal);
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
  }),
  historyReport: (filter: ApiAnalyticsTimeOffLeaveUsedFilter) => ({
    queryKey: [filter],
    queryFn: async ({ signal }) => {
      const result = await apiAnalytics.timeOff.historyReport(filter, signal);
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
  }),
  policyReport: (filter: ApiAnalyticsTimeOffLeavePolicyFilter) => ({
    queryKey: [filter],
    queryFn: async ({ signal }) => {
      const result = await apiAnalytics.timeOff.policyReport(filter, signal);
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
  }),
});

export const useTimeOffAnalyticsBalancesSummary = ({
  filter,
  enabled = true,
}: {
  filter: ApiAnalyticsTimeOffBalanceSummaryFilter;
  enabled: boolean;
}) => {
  return useQuery({
    ...timeOffAnalyticsKeys.balancesSummary(filter),
    enabled,
  });
};

export const useTimeOffAnalyticsBalancesByCategory = ({
  filter,
  enabled = true,
}: {
  filter: ApiAnalyticsTimeOffBalanceFilter;
  enabled: boolean;
}) => {
  return useQuery({
    ...timeOffAnalyticsKeys.balancesByCategoryReport(filter),
    enabled,
  });
};

export const useTimeOffAnalyticsHistory = ({
  filter,
  enabled = true,
}: {
  filter: ApiAnalyticsTimeOffLeaveUsedFilter;
  enabled: boolean;
}) => {
  return useQuery({
    ...timeOffAnalyticsKeys.historyReport(filter),
    enabled,
  });
};

export const useTimeOffAnalyticsPolicyReport = ({
  filter,
  enabled = true,
}: {
  filter: ApiAnalyticsTimeOffLeavePolicyFilter;
  enabled: boolean;
}) => {
  return useQuery({
    ...timeOffAnalyticsKeys.policyReport(filter),
    enabled,
  });
};
